"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _eqmodJsQrcodelib = require("eqmod-js-qrcodelib");

var _HttpRequest = require("../../../utils/HttpRequest");

var _BuildConstants = require("../../../utils/BuildConstants");

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _DateTimeHelper = require("../../../helpers/DateTimeHelper");

var _Button = _interopRequireDefault(require("../Button"));

var _QRCodeReferrer = _interopRequireDefault(require("./QRCodeReferrer.scss"));

var _strings = require("./strings");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var START_TIMER = 240; // seconds (= 4min)

var QRCodeReferrer = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(QRCodeReferrer, _Component);

  var _super = _createSuper(QRCodeReferrer);

  function QRCodeReferrer() {
    var _this;

    (0, _classCallCheck2["default"])(this, QRCodeReferrer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      qrCodeGenerated: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "generateQRCode", function () {
      var hostname = window && window.location && window.location.hostname ? window.location.hostname : 'hostname not set';
      var data = {
        systemAction: 'storeHostName',
        actionParams: {
          hostname: hostname
        }
      };
      (0, _eqmodJsQrcodelib.generateQRCodeInCanvas)('generic', (0, _stringify["default"])(data), _eqmodJsQrcodelib.QR_CONTENT_TYPES.SYS_MESSAGE, 'qrrefcanvas').then(function (code) {
        console.log(code);
      })["catch"](function (e) {
        console.error(e);

        _this.setState({
          error: (0, _strings.getString)('QR_REFERRER_ERROR_LOAD_CODE')
        });
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(QRCodeReferrer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.generateQRCode();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeReferrer["default"].container
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeReferrer["default"].headline
      }, (0, _strings.getString)('QR_REFERRER_HEADLINE')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeReferrer["default"].infotext
      }, (0, _strings.getString)('QR_REFERRER_INFOTEXT')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeReferrer["default"].wrapper
      }, /*#__PURE__*/_react["default"].createElement("canvas", {
        id: "qrrefcanvas",
        className: _QRCodeReferrer["default"].canvas
      })));
    }
  }]);
  return QRCodeReferrer;
}(_react.Component);

var _default = QRCodeReferrer;
exports["default"] = _default;